import { IconProps } from '../types';

function ArrowUpTriangleSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      className={className || 'h-5 w-5'}
      fill="currentColor"
      id={id}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" d="M10 8 L4 14 L16 14 Z"></path>
    </svg>
  );
}

export default ArrowUpTriangleSolidIcon;
